"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applicationCommon_en_us = void 0;
function applicationCommon_en_us() {
    return {
        "applications.title": "Working Title",
        "applications.empty.headline": "Create your first application",
        "applications.empty.message": "Applications are the best and easiest way to bring your content to your customers. Applications run in every browser and can be installed on Android and iOS devices.",
        "applications.empty.create": "Create Application",
        "applications.creationdialog.title": "Create new application",
        "applications.creationdialog.description": "The working title is just for you and your colleagues to recognize the application lateron.",
        "applications.deletion.title": "Delete Application",
        "applications.deletion.message": "Do you really want to delete this application? This cannot be undone. The content will stay untouched!"
    };
}
exports.applicationCommon_en_us = applicationCommon_en_us;
